import { FileClient } from "../RestClient";

// 得意先元帳 excel(csv) 出力リクエスト
export type B030080Request = {
  urikakeYm: string;
  urikakejoken: string;
  shutsuryokuKbn: string;
} & Partial<{
  bumonCdFrom: string;
  bumonNmrFrom: string;
  bumonCdTo: string;
  bumonNmrTo: string;
  shainCdFrom: string;
  shainNmFrom: string;
  shainCdTo: string;
  shainNmTo: string;
  urikakeCdFrom: string;
  urikakeshitenCdFrom: string;
  urikakeNmrFrom: string;
  urikakeCdTo: string;
  urikakeshitenCdTo: string;
  urikakeNmrTo: string;
}>;

// 得意先元帳 excel(csv) 出力処理
export const B030080GetExcel = (props: B030080Request) => {
  return FileClient.get("b030080/get/excel", {
    params: props,
  });
};
